import {Component, input, output} from '@angular/core';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-consent-banner',
  templateUrl: './consent-banner.component.html',
  styleUrl: './consent-banner.component.scss',
})
export class ConsentBannerComponent {
  onConsentGranted = output();
  onRejected = output();

  readonly acceptLabel = input<string>('Accept');
  readonly denyLabel = input<string>('Deny');

  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
